import React from "react";
import { useSelector } from "react-redux";
import { categoryImg } from "./CategoryImages";
import "./CategoryList.scss"
export default function CategoryList ({history}) {
    const category = useSelector(state => state?.category);
    const handlenav = (categoryItem) => {
      history.push(`/category/${categoryItem?.label}`); 
    }
    return(
        <div className="category">
             <div className="category-cont">
                    <div className="category-head">Shop by Category</div>
                    
                </div>
            <div className="category-list">
                {category.map((categoryItem, index) => (
                    <div className="category-item" role={"button"} onClick={()=>{handlenav(categoryItem)}}>
                        <div className="image-container">
                        <img className="categoryImg" src={categoryImg[categoryItem?.label]} alt={categoryItem?.label}/>
                        </div>
                        <div className="category-txt">{categoryItem?.label}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}